export const GET_ADMIN_SERVICES = 'GET_ADMIN_SERVICES';
export const SINGLE_ADMIN_SERVICES = 'SINGLE_ADMIN_SERVICES';
export const GET_SERVICES = 'GET_SERVICES';
export const RESET_SINGLE_SERVICES = 'RESET_SINGLE_SERVICES';